import React from "react";
import { StickyCta } from "./StepIntro";
import { Checkbox } from "../ui/checkbox";
import { Link } from "react-router-dom";

/**
 * 18+ age gate — cannot proceed without checking the box.
 */
export function StepAgeGate({ agreed, onAgreedChange, onNext }) {
    return (
        <div className="pb-24" data-testid="step-age-gate">
            <div className="mt-2 space-y-4">
                <span className="eyebrow" data-testid="age-eyebrow">
                    Before we begin
                </span>
                <h1 className="font-display text-[2rem] font-medium leading-tight text-meow-charcoal">
                    A quick confirmation.
                </h1>
                <p className="text-[15px] leading-relaxed text-meow-muted">
                    MeowMD is meant for adults responsible for a cat&apos;s care.
                    Please confirm the following before continuing.
                </p>
            </div>

            <label
                htmlFor="age-agree"
                className={
                    "mt-6 flex items-start gap-3 rounded-2xl border p-4 transition-colors " +
                    (agreed
                        ? "border-meow-teal bg-[#F4FAF9]"
                        : "border-transparent bg-white shadow-[0_8px_30px_rgba(42,42,42,0.04)]")
                }
                data-testid="age-agree-row"
            >
                <Checkbox
                    id="age-agree"
                    checked={agreed}
                    onCheckedChange={(v) => onAgreedChange(!!v)}
                    className="mt-1 h-5 w-5 border-black/20 data-[state=checked]:border-meow-teal data-[state=checked]:bg-meow-teal"
                    data-testid="age-agree-checkbox"
                />
                <div>
                    <div className="font-display text-[15px] font-medium text-meow-charcoal">
                        I'm 18 or older and this cat is under my care.
                    </div>
                    <p className="mt-1 text-[13px] leading-relaxed text-meow-muted">
                        I understand this tool is educational and{" "}
                        <Link
                            to="/disclaimer"
                            className="font-medium text-meow-teal underline-offset-2 hover:underline"
                            data-testid="age-disclaimer-link"
                        >
                            not a substitute for a vet
                        </Link>
                        .
                    </p>
                </div>
            </label>

            <StickyCta>
                <button
                    type="button"
                    className="meow-btn-primary w-full"
                    disabled={!agreed}
                    onClick={onNext}
                    data-testid="age-continue-btn"
                >
                    Continue
                </button>
            </StickyCta>
        </div>
    );
}
